import { createLabTest } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  CreateLabTestRequestT,
  CreateLabTestResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchCreateLabTest(
  request: CreateLabTestRequestT,
  signal?: AbortSignal
): Promise<CreateLabTestResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await createLabTest(request, config);
  return lotusHealthZod.createLabTestResponse.parse(response.data) as CreateLabTestResponseT;
}
